import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaLongArrowAltRight,
  FaTimes,
} from "react-icons/fa";
import API_BASE_URL from "../config/api";
import "./Collections.css";

function Collection() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCollection, setActiveCollection] = useState("ALL");

  /* 
     PRODUCT IMAGE URL
*/

  const imageUrl = (image) => {
    if (!image) return "";

    if (image.startsWith("http")) {
      return image;
    }

    return `${API_BASE_URL}/${image.replace(/^\/+/, "")}`;
  };

  /* 
     FETCH PRODUCTS
*/

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/products`
        );

        const data = await response.json();

        if (data.success) {
          setProducts(data.products || []);
        }
      } catch (error) {
        console.error("Collection products error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  /* 
     FILTER PRODUCTS
*/

  const filteredProducts =
    activeCollection === "ALL"
      ? products
      : products.filter(
          (product) =>
            String(product.collection || "").toUpperCase() ===
            activeCollection
        );

  /* 
     SELECT COLLECTION
*/

  const selectCollection = (collection) => {
    setActiveCollection(collection);

    setTimeout(() => {
      document
        .getElementById("tv-collection-watches")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    }, 50);
  };

  /* 
     COLLECTION TITLES
*/

  const collectionTitle = {
    ALL: "Men's Timepieces",
    CLASSIC: "Classic Timepieces",
    PREMIUM: "Premium Timepieces",
    ESSENTIAL: "Essential Timepieces",
  };

  return (
    <main className="tv-collection-page">

      {/* 
          HERO
    */}

      <section
        className="tv-collection-hero"
        style={{
          backgroundImage: `
            linear-gradient(
              90deg,
              rgba(18, 36, 25, 0.95) 0%,
              rgba(18, 36, 25, 0.72) 45%,
              rgba(18, 36, 25, 0.25) 100%
            ),
            url("/contact10.webp")
          `,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="tv-collection-hero-overlay"></div>

        <div className="tv-collection-hero-content">

          <span className="tv-collection-eyebrow">
            TIME VALLEY · MEN'S COLLECTION
          </span>

          <h1>
            Timepieces for
            <span> the Modern Man</span>
          </h1>

          <p>
            Refined watches designed for confidence,
            character and timeless presence.
          </p>

          <button
            type="button"
            onClick={() => selectCollection("ALL")}
            className="tv-collection-hero-btn"
          >
            Explore Collection
            <FaArrowRight />
          </button>

        </div>

        <div className="tv-collection-scroll">
          <span>SCROLL TO DISCOVER</span>
          <div></div>
        </div>
      </section>

      {/* 
          INTRO
    */}

      <section className="tv-collection-intro">

        <div className="tv-collection-intro-line"></div>

        <span className="tv-collection-intro-label">
          THE TIME VALLEY STANDARD
        </span>

        <h2>
          Designed to be noticed.
          <br />
          <em>Made to be remembered.</em>
        </h2>

        <p>
          Discover a considered collection of men's watches,
          combining sophisticated design with everyday versatility.
          Every Time Valley timepiece is created to become part of
          your story.
        </p>

      </section>

      {/* 
          COLLECTION NAVIGATION
    */}

      <section className="tv-collection-navigation">

        <div className="tv-collection-section-heading">

          <div>
            <span>EXPLORE</span>
            <h2>Men's Collections</h2>
          </div>

          <p>
            Find the watch that matches your
            style, occasion and character.
          </p>

        </div>

        <div className="tv-collection-grid">

          {/* CLASSIC */}

          <button
            type="button"
            className={`tv-collection-card ${
              activeCollection === "CLASSIC"
                ? "tv-collection-card-active"
                : ""
            }`}
            onClick={() => selectCollection("CLASSIC")}
          >
            <div className="tv-collection-card-number">
              01
            </div>

            <div className="tv-collection-card-content">

              <span>TIMELESS DESIGN</span>

              <h3>Classic</h3>

              <p>
                Elegant silhouettes for every occasion.
              </p>

            </div>

            <FaLongArrowAltRight />
          </button>

          {/* PREMIUM */}

          <button
            type="button"
            className={`tv-collection-card ${
              activeCollection === "PREMIUM"
                ? "tv-collection-card-active"
                : ""
            }`}
            onClick={() => selectCollection("PREMIUM")}
          >
            <div className="tv-collection-card-number">
              02
            </div>

            <div className="tv-collection-card-content">

              <span>STATEMENT PIECES</span>

              <h3>Premium</h3>

              <p>
                Distinctive watches with elevated character.
              </p>

            </div>

            <FaLongArrowAltRight />
          </button>

          {/* ESSENTIAL */}

          <button
            type="button"
            className={`tv-collection-card ${
              activeCollection === "ESSENTIAL"
                ? "tv-collection-card-active"
                : ""
            }`}
            onClick={() => selectCollection("ESSENTIAL")}
          >
            <div className="tv-collection-card-number">
              03
            </div>

            <div className="tv-collection-card-content">

              <span>EVERYDAY ESSENTIALS</span>

              <h3>Essential</h3>

              <p>
                Refined style made for everyday wear.
              </p>

            </div>

            <FaLongArrowAltRight />
          </button>

        </div>
      </section>

      {/* 
          PRODUCTS
    */}

      <section
        className="tv-collection-products"
        id="tv-collection-watches"
      >

        <div className="tv-collection-products-heading">

          <div>
            <span>
              {activeCollection === "ALL"
                ? "TIME VALLEY"
                : `${activeCollection} COLLECTION`}
            </span>

            <h2>
              {collectionTitle[activeCollection]}
            </h2>
          </div>

          <div className="tv-collection-heading-right">

            {activeCollection !== "ALL" && (
              <button
                type="button"
                className="tv-collection-clear-filter"
                onClick={() => setActiveCollection("ALL")}
              >
                <FaTimes />
                All Watches
              </button>
            )}

            <span className="tv-collection-product-count">
              {filteredProducts.length} TIMEPIECES
            </span>

          </div>

        </div>

        {/* LOADING */}

        {loading ? (

          <div className="tv-collection-loading">

            <span></span>

            <p>
              Discovering the collection...
            </p>

          </div>

        ) : filteredProducts.length === 0 ? (

          /* EMPTY */

          <div className="tv-collection-empty">

            <span className="tv-collection-empty-label">
              {activeCollection} COLLECTION
            </span>

            <h3>
              Collection Coming Soon
            </h3>

            <p>
              No timepieces are currently available
              in this collection.
            </p>

            {activeCollection !== "ALL" && (
              <button
                type="button"
                onClick={() => setActiveCollection("ALL")}
                className="tv-collection-empty-btn"
              >
                View All Watches
                <FaArrowRight />
              </button>
            )}

          </div>

        ) : (

          /* PRODUCTS */

          <div className="tv-collection-product-grid">

            {filteredProducts.map((product) => (

              <Link
                to={`/product/${product.id}`}
                className="tv-collection-product-card"
                key={product.id}
              >

                <div className="tv-collection-product-image">

                  {product.collection && (
                    <span className="tv-collection-product-badge">
                      {product.collection}
                    </span>
                  )}

                  {product.tag && (
                    <span className="tv-collection-product-tag">
                      {product.tag}
                    </span>
                  )}

                  <img
                    src={imageUrl(product.image1)}
                    alt={product.name}
                  />

                  <div className="tv-collection-product-view">
                    VIEW TIMEPIECE
                    <FaArrowRight />
                  </div>

                </div>

                <div className="tv-collection-product-info">

                  <span>
                    TIME VALLEY
                  </span>

                  <h3>
                    {product.name}
                  </h3>

                  <p>
                    Rs : {" "}
                    {Number(
                      product.price || 0
                    ).toLocaleString()}
                  </p>

                </div>

              </Link>

            ))}

          </div>

        )}

      </section>

      {/* 
          CTA
    */}

      <section
        className="tv-collection-cta"
        style={{
          backgroundImage: `
            linear-gradient(
              90deg,
              rgba(18, 36, 25, 0.96) 0%,
              rgba(18, 36, 25, 0.65) 55%,
              rgba(18, 36, 25, 0.3) 100%
            ),
            url("/about10.webp")
          `,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >

        <div className="tv-collection-cta-content">

          <span>
            YOUR TIME. YOUR STATEMENT.
          </span>

          <h2>
            Wear something
            <br />
            <em>worth remembering.</em>
          </h2>

          <Link
            to="/shop"
            className="tv-collection-cta-btn"
          >
            Shop All Watches
            <FaArrowRight />
          </Link>

        </div>

      </section>

    </main>
  );
}

export default Collection;